// 入口函数，在页面加载完成后执行
function main() {
  Alpine.data('gocHeaderDropdownPlane', function () {

    const handlesStr = this.$el.dataset.handles || ""
    const handles = handlesStr.split(',')

    return {
      handles: handles,
      handle: handles[0],

      /**
       * 判断当前 handle 是否激活
       * @param {string} handle
       * @returns
       */
      isActive(handle) {
        if (!this.handle) {
          return false
        }
        return this.handle === handle
      },

      onHover(handle) {
        this.handle = handle
      }
    }
  })
}

document.addEventListener('alpine:init', main)
